export const FLAGGING_RATE_LOWER_THRESHOLD = 0.1;
export const FLAGGING_RATE_HIGHER_THRESHOLD = 0.3;
